import * as React from 'react';

import { ContextualHelp, Typography2 } from '@coursera/cds-core';

import KeyInformationDetailsItem from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationDetailsItem';
import AvailabilityDetailsModal from 'bundles/unified-description-page-common/components/shared/modals/AvailabilityDetailsModal';
import type { FixedSessionFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedEnterpriseEntitiesFragments';

import _t from 'i18n!nls/xdp';

type Props = {
  // Courses/projects can have fixed session dates.
  fixedSession?: FixedSessionFragment | null;
  // True if used on s12n/prof cert page, if their courses contain fixed sessions.
  childrenHaveFixedSessions?: boolean;
  isSelectedForCredit?: boolean;
  productName: string;
};

const KeyInformationEnterpriseCreditItem = ({
  fixedSession,
  isSelectedForCredit,
  productName,
  childrenHaveFixedSessions,
}: Props) => {
  return (
    <KeyInformationDetailsItem
      title={_t('Earn degree credit')}
      subtitle={
        <ContextualHelp
          helpToggleProps={{
            'aria-label': _t('Information about the products credit.'),
          }}
          tooltipProps={{
            closeButtonProps: {
              'aria-label': _t('Close modal about the products credit.'),
            },
          }}
          label={
            <Typography2 component="p" variant="bodySecondary">
              {_t('Learn more')}
            </Typography2>
          }
        >
          {({ onClose, isExpanded }) => {
            return (
              <AvailabilityDetailsModal
                open={!!isExpanded}
                setOpen={onClose}
                productName={productName}
                fixedSession={fixedSession}
                isSelectedForCredit={isSelectedForCredit}
                childrenHaveFixedSessions={childrenHaveFixedSessions}
              />
            );
          }}
        </ContextualHelp>
      }
    />
  );
};

export default KeyInformationEnterpriseCreditItem;
